import React, { Component } from 'react';
import Parse                from 'parse';
import classNames           from 'classnames/bind';
import Utils                from '../../Utils/Utility';
import Api                  from '../../Utils/api';
import RegisterBusiness     from './RegisterBusiness';
import { Link }             from 'react-router';

let wllogo = require('../../../img/wl-logo-blue.png');

export default class RegisterUser extends Component {

    constructor(props){
        super(props);
        this.state = {
            name                         : '',
            email                        : '',
            password                     : '',
            rePassword                   : '',
            ownerPhoneNumber             : '',
            agreement                    : false,
            pwdVerficationLbl            : "Verify Password",
            isUserAccCreated             : false,
            isEmailVerified              : false,
            resendVerificationEmailCount : 0,
            error                        : null
        };

        this._bind(
            'changeName'             , 'changelName'      ,
            'changeEmail'            , 'changePassword'   ,
            'changeOwnerPhoneNumber' , 'changeRePassword' ,
            'changeAgreement'        , 'validatePassword' ,
            'handleSubmit'           , 'verifyEmail'      ,
            'informOthers'           , 'proceedFurther'
        );
    }

    _bind(...methods) {
        methods.forEach( (method) => this[method] = this[method].bind(this) );
     }

     //Owner fieldsets starts

    changeName(e) {
        this.setState({name : e.target.value});
    }

    changelName(e) {
        this.setState({lName : e.target.value});
    }

    changeEmail(e) {
         this.setState({email : e.target.value});
    }

    changeAgreement(e) {
         this.setState({agreement : !this.state.agreement});
    }

    changePassword(e) {
        this.setState({password : e.target.value});
    }

    changeRePassword(e) {
        this.setState({
            rePassword : e.target.value
        });
    }

    changeOwnerPhoneNumber(e) {
        this.setState({ownerPhoneNumber : e.target.value});
    }

     //Owner fieldsets ends

    //User Register form submit
    handleSubmit(e){
        e.preventDefault();

        this.setState({
            showSpinner : true
        });

        let user = new Parse.User();

        user.set("username"    , this.state.email);
        user.set("password"    , this.state.password);
        user.set("email"       , this.state.email);
        user.set("name"        , this.state.name);
        user.set("phoneNumber" , this.state.ownerPhoneNumber);
        user.set("userType"    , "Manager");
        user.set("isTest"      , TEST_MODE);

        user.signUp(null).then((user)=>{
            console.log("New user created");
            return Utils.updateUserAcl(user);
        }).then(
            () => {
                let userId       = Parse.User.current().id;
                let sessionToken = Parse.User.current().getSessionToken();
                return Api.requestEmailVerification(userId, sessionToken);
            })
        .then(
            (user) => {
                this.setState({
                    user             : user,
                    isUserAccCreated : true,
                    showSpinner      : false,
                    isEmailVerified  : false
                },
                this.informOthers
                );
            },
            (error) => {
                console.log("Error in signUp new user:"+error.message);
                this.setState({
                    error       : error.message,
                    showSpinner : false
                });
            }
        );
    }

    validatePassword(e) {
        let condition = !(Utils.isEmpty(this.state.password)) && (this.state.password === this.state.rePassword);
        this.setState({
            passwordMatches   : condition,
            pwdVerficationLbl : ( condition ? "Password Matches" : "Your password does not match !" )
        });
    }

    verifyEmail() {
        let currentUser = Parse.User.current();
        currentUser.fetch().then(
            (user) =>
            {
                if(user.get("emailVerified")){
                    this.setState({ isEmailVerified : true }, this.informOthers);
                }
            },
            () =>
            {
                console.log("Couldn't fetch latest user data");
            }
        );
    }

    proceedFurther() {
        this.setState({ isEmailVerified : true }, this.informOthers);
    }

    resendVerificationEmail() {

        console.log("count:"+this.state.resendVerificationEmailCount);
        if (this.state.resendVerificationEmailCount == 1){
             return;
        }

        let userId       = Parse.User.current().id;
        let sessionToken = Parse.User.current().getSessionToken();
        Api.requestEmailVerification(userId, sessionToken)
            .then((success) => {
                this.setState((prevState, props) => {
                    return {resendVerificationEmailCount : prevState.resendVerificationEmailCount + 1 }
                });
            },
            (error) => {
                console.log(error);
            });
    }

    informOthers() {
        this.props.callbackParent(this.state.isEmailVerified);
    }

    componentWillMount() {
        let currentUser = Parse.User.current();

        if((typeof this.props.emailVerified!=='undefined')||currentUser){
            this.setState({
                    isUserAccCreated : true,
                    email            : currentUser.get("email")
                });
        }
    }

    render() {
        let pwdVerficationLbl = this.state.pwdVerficationLbl;
        let condition         = !(Utils.isEmpty(this.state.password)) && this.state.passwordMatches === true;
        let isPasswordMatches = this.state.passwordMatches;

        let pwdVerfiStyleObj;
        let pwdFeedbackStyleObj;
        if (!((typeof isPasswordMatches) === 'undefined')) {

            pwdVerfiStyleObj = {
                'has-feedback' : true,
                'has-success'  : isPasswordMatches,
                'has-error'    : !isPasswordMatches
            };

            pwdFeedbackStyleObj = {
                'form-control-feedback' : true,
                'glyphicon-ok'          : isPasswordMatches,
                'glyphicon-remove'      : !isPasswordMatches
            };
        }

        let pwdVerficationStyle
        = classNames({
            'form-group'   : true,
            }, pwdVerfiStyleObj);

        let pwdFeedbackStyle
        = classNames({
            'glyphicon':true
        }, pwdFeedbackStyleObj);

        let errorStyle
        = classNames({
            'col-md-12'    : true,
            'text-center'  : true,
            'alert'        : this.state.error,
            'alert-danger' : this.state.error
        });

        let RegisterUserComp = (

        <div className="container register-pg">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h2>
                        Welcome Aboard!
                    </h2>
                    <p className="para">
                        Please fill out the information below
                    </p>
                </div>
            </div>

            <form className="form-horizontal" onSubmit={this.handleSubmit}>
                <div className="col-md-12" style={{marginLeft : 50, marginRight : 50}}>
                      <fieldset>
                          {/*<br/>*/}
                          {/*<h3>Restaurant Owner Details</h3>*/}
                          <br/>

                          <div className="form-group">
                            <div className="col-xs-12">
                                <label className="control-label" htmlFor="lFName">Legal Name of Owner</label>
                            </div>
                            <div className="col-xs-12">
                                <input
                                    id          = "lFName"
                                    ref         = "lname"
                                    type        = "text"
                                    placeholder = "Legal Name"
                                    onChange    = {this.changeName}
                                    value       = {this.state.Name}
                                    className   = "form-control"
                                    required
                                    autoFocus
                                />
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="col-xs-12">
                                <label htmlFor="ownerPhone">Phone</label>
                                <input
                                    id          = "ownerPhone"
                                    type        = "tel"
                                    ref         = "ownerPhone"
                                    placeholder = "Owner Phone No."
                                    title       = "XXXXXXXXXX"
                                    onChange    = {this.changeOwnerPhoneNumber}
                                    value       = {this.state.ownerPhoneNumber}
                                    className   = "form-control"
                                    pattern     = "\d{3}\d{3}\d{4}"
                                    required
                                />
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="col-xs-12">
                                <label htmlFor="email">Email</label>
                                <input
                                    id          = "email"
                                    ref         = "email"
                                    type        = "email"
                                    placeholder = "Owner email (this will also be your username)"
                                    onChange    = {this.changeEmail}
                                    value       = {this.state.email}
                                    className   = "form-control"
                                    required
                                    autoFocus
                                />
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="col-xs-12">
                                <label htmlFor="inputPassword"  className="control-label">Password</label>
                                <input
                                    id          = "inputPassword"
                                    ref         = "inputPassword"
                                    type        = "password"
                                    onChange    = {this.changePassword}
                                    value       = {this.state.password}
                                    className   = "form-control"
                                    id          = "inputPassword"
                                    placeholder = "Create a strong password"
                                    required
                                />
                            </div>
                          </div>

                          <div className={pwdVerficationStyle}>
                            <div className="col-xs-12">
                                <label htmlFor="rePassword" className="control-label">{pwdVerficationLbl}</label>
                                <input
                                    className   = "form-control"
                                    id          = "rePassword"
                                    ref         = "rePassword"
                                    type        = "password"
                                    onChange    = {this.changeRePassword}
                                    onBlur      = {this.validatePassword}
                                    value       = {this.state.rePassword}
                                    className   = "form-control"
                                    id          = "inputPassword"
                                    placeholder = "Verify Password"
                                    required
                                />
                                <span className={pwdFeedbackStyle} aria-hidden="true"></span>
                            </div>
                          </div>

                    </fieldset>
                </div>

                <div className="row">
                    <div className="col-md-12" style={{marginLeft : 50, marginRight : 50}}>
                        <div className={errorStyle}>
                            <p>{this.state.error}</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <fieldset>
                              <div className="form-group">
                                 <div className="col-xs-12 text-center">
                                     <button className="btn-register-cta">
                                         {
                                             this.state.showSpinner ? <i className="fa fa-spinner fa-pulse"></i> : null
                                         }
                                         Create My Account
                                     </button>
                                 </div>
                              </div>
                        </fieldset>
                    </div>
                </div>
            </form>
        </div>
        );


        return  !this.state.isUserAccCreated
            ? RegisterUserComp
            : (
                <AfterSignupComp
                    email                        = {this.state.email}
                    proceedFurther               = {this.proceedFurther}
                    resendVerificationEmail      = {this.resendVerificationEmail.bind(this)}
                    resendVerificationEmailCount = {this.state.resendVerificationEmailCount}
                />
            );

    }
}

const AfterSignupComp = ({email, proceedFurther, resendVerificationEmail, resendVerificationEmailCount}) => (
   <div className="container register-pg">
        <div className="row">
            <div className="col-sm-12 text-center">

                <img
                    className = "center-block img-responsive"
                    src       = {wllogo}
                    alt       = "freshbytes"
                />

                <h2>
                    Registration email sent.
                </h2>
                <div>
                    <h4>Registration email sent to ({email}). Open this email to finish<br/>
                        signUp.
                    </h4>
                </div>
                <hr/>
                <div>
                    <h4>If you haven’t received our email in about 15 minutes, please check your spam folder. If you<br/>
                        find it there, please mark the email as "Not Junk". <br />
                        If you still haven’t received it, please click
                        <button
                            type      = "button"
                            className = "btn btn-link"
                            onClick   = {resendVerificationEmail}
                        >
                            here to send verification email again.
                        </button>
                    </h4>
                    {
                        resendVerificationEmailCount > 0 ?
                            (
                            <div>
                                <br/>
                                <h4>Email verification link sent again. </h4>
                            </div>
                            )
                        : null
                    }
                </div>
            </div>
            {
                /*
                   <div className="form-group">
                   <div className="col-xs-12 text-center">
                   <button
                        className = "btn-register-cta"
                        onClick   = {proceedFurther}
                        style     = {{marginTop : 60, marginBottom : 191}}
                    >
                        Continue
                    </button>
                </div>
                </div>
                 */
            }
        </div>
    </div>

);

const EmailVerificationComp = ({ email, verifyEmail, resendVerificationEmail }) => (

    <div className="container register-pg">
        <div className="row">
            <div className="col-sm-12 text-center">

                <img
                    className = "center-block img-responsive"
                    src       = {wllogo}
                    alt       = "freshbytes"
                />

                <h2>
                    Please verify your email to continue.
                </h2>
                <div>
                    <h4>Please check your email ({email}) to confirm your account.
                        <br/> Click on the button below, once you have confirmed your email account.
                    </h4>
                </div>
                <hr/>
                <div>
                    <h4>If you haven’t received our email in about 5 minutes, please check your spam folder. If you<br/>
                        still haven’t received it, please click
                        <button
                            type      = "button"
                            className = "btn btn-link"
                            onClick   = {resendVerificationEmail}
                        >
                            here to send verification email again.
                        </button>
                    </h4>
                </div>
            </div>
            <div className="form-group">
                <div className="col-xs-12 text-center">
                    <button
                        className = "btn-register-cta"
                        onClick   = {verifyEmail}
                        style     = {{marginTop : 60, marginBottom : 191}}
                    >
                        Confirmed
                    </button>
                </div>
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// src/components/register/RegisterUser.js